<template>
    <UiLinkList class="link-list" :blok="blok" />
</template>

<script setup>
defineProps({ blok: Object });
</script>

<style lang="postcss" scoped>
.link-list {
    @apply pt-4;
    :deep(.main-link-wrapper) {
        .link-section-title {
            @apply text-center text-primary pb-4;
        }
        .links {
            @apply px-8 max-md:grid-cols-[repeat(var(--column-count-mobile),1fr)];
            .link-wrapper {
                @apply p-2;
            }
            a {
                @apply text-[var(--link-list-item-color)];
                &:hover {
                    @apply text-primary no-underline;
                }
            }
        }
    }
}
</style>
